import { createColumn, defaultColumns, inputTextField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Contract Access Price',
    field: 'contractPrice',
    type: 'number',
    component: inputTextField({ req: true, type: 'number', money: true })
  })
].concat(defaultColumns)
